import { setDrawerOpen } from 'features/ui/model/uiSlice';
import { DrawerContent } from 'shared/ui/Drawer/DrawerStyles';
import {
  Box,
  Button,
  CircularProgress,
  Drawer,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useAppDispatch, useAppSelector } from 'app/store';
import { Controller, useForm } from 'react-hook-form';
import React, { useEffect } from 'react';
import { useGetCountriesQuery } from 'features/getCountries/api/getCountriesApi';
import { isEmptyArr } from 'shared/utils/isEmpty';
import { useAddCitiesMutation, useEditCitiesMutation } from 'features/useCity/api/useCityApi';

type FormDataType = { name: string; country_id: number | null; country: string };

export const CityCreateWidget = ({
  city,
  setCity,
  cityCountry,
  refetch,
}: {
  city: any;
  setCity: any;
  cityCountry: any;
  refetch: any;
}) => {
  const dispatch = useAppDispatch();
  const { isDrawerOpen } = useAppSelector((state) => state.ui);

  const countries = useGetCountriesQuery(null);

  const [addCity] = useAddCitiesMutation();
  const [editCity] = useEditCitiesMutation();

  const { control, getValues, setValue, reset } = useForm<FormDataType>({
    defaultValues: { name: '', country_id: null, country: '' },
  });

  useEffect(() => {
    if (city && cityCountry()) {
      setValue('name', city.name);
      setValue('country_id', city.country_id);
      setValue('country', cityCountry().name);
    }
  }, [city, cityCountry, setValue]);

  const onSendData = async () => {
    const data =
      city && city.id ? await editCity({ id: city.id, body: getValues() }) : await addCity({ body: getValues() });

    if (data) {
      refetch();
      dispatch(setDrawerOpen(false));
      setCity({});
    }
  };

  return (
    <Drawer
      anchor="right"
      open={isDrawerOpen}
      onClose={() => dispatch(setDrawerOpen(false))}
    >
      <DrawerContent style={{ width: '800px' }}>
        <div className="header">
          <Typography
            variant="h5"
            sx={{ fontWeight: '600' }}
          >
            {city?.id ? 'Изменить' : 'Добавить'} город
          </Typography>

          <IconButton
            onClick={() => {
              dispatch(setDrawerOpen(false));
              setCity({});
              reset();
            }}
            sx={{ color: '#000' }}
          >
            <CloseIcon />
          </IconButton>
        </div>

        <div className="content">
          {!countries.isFetching ? (
            countries.isSuccess &&
            !isEmptyArr(countries.data) && (
              <Controller
                name="country"
                control={control}
                render={({ field }) => (
                  <FormControl fullWidth>
                    <InputLabel id="country-select-label">Страна</InputLabel>
                    <Select
                      sx={{ minWidth: '120px' }}
                      labelId="country-select-label"
                      id="country-simple-select"
                      label="Страна"
                      {...field}
                    >
                      {countries.data.map((item) => (
                        <MenuItem
                          onClick={() => {
                            setValue('country', item.name);
                            setValue('country_id', item.id);
                          }}
                          key={item.id}
                          value={item.name}
                        >
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
              />
            )
          ) : (
            <Stack alignItems="center">
              <CircularProgress />
            </Stack>
          )}

          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <FormControl sx={{ width: '100%' }}>
              <Controller
                name="name"
                control={control}
                render={({ field }) => (
                  <TextField
                    label="Название города"
                    fullWidth
                    sx={{ margin: '24px 0' }}
                    {...field}
                  />
                )}
              />
            </FormControl>
          </Box>

          <Button
            onClick={onSendData}
            variant="contained"
            sx={{ textTransform: 'none', marginTop: '24px' }}
          >
            {city?.id ? 'Изменить' : 'Добавить'}
          </Button>
        </div>
      </DrawerContent>
    </Drawer>
  );
};
